import React from "react";
import AccountsBase from "@/pages/AccountsBase";
export default function AccountsPayable() { return <AccountsBase kind="payable" />; }
